import Foundation from "@microsoft/fast-components-foundation-react";
import { TextField as BaseTextField } from "@microsoft/fast-components-react-base";
import { classNames } from "@microsoft/fast-web-utilities";
import React from "react";
import { DisplayNamePrefix } from "../utilities";
import { TextFieldAppearance, } from "./text-field.props";
class TextField extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            appearance: void 0,
            managedClasses: void 0,
        };
    }
    /**
     * Renders the component
     */
    render() {
        return (React.createElement(BaseTextField, Object.assign({}, this.unhandledProps(), { className: this.generateClassNames(), managedClasses: this.props.managedClasses })));
    }
    /**
     * Generates class names
     */
    generateClassNames() {
        return super.generateClassNames(classNames([
            this.props.managedClasses[`textField__${TextFieldAppearance[this.props.appearance]}`],
            !!this.props.appearance,
        ]));
    }
}
TextField.displayName = `${DisplayNamePrefix}TextField`;
TextField.defaultProps = {
    managedClasses: {},
};
export default TextField;
export * from "./text-field.props";
